module.exports = __webpack_public_path__ + "static/media/rp01.ba43ab79.webp";